import trainListEnter from 'trainListEnter';

new Vue({
  render: h => h(trainListEnter)
}).$mount('#page')



// WEBPACK FOOTER //
// ./src/views/train/trainList/trainList.js